var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconOthers = function SvgIconOthers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 41.6 26.55 28.45l2.3-2.3L42 39.3Zm-28.5-2.3q-2.65-2.9-3.925-6.425T6 25.7q0-3.9 1.45-7.6 1.45-3.7 4.4-6.65t6.675-4.4Q22.25 5.6 26.15 5.6q3.65 0 7.175 1.275T39.7 10.8Zm.15-4.45 3.45-3.5q-.8-1.1-1.6-2.375t-1.475-2.7q-.675-1.425-1.125-2.95-.45-1.525-.6-3.125-1.35 3.7-.925 7.55.425 3.85 2.275 7.1Zm5.85-5.75 12.3-12.4q-2.3-1.8-4.675-2.825-2.375-1.025-4.525-1.35-2.15-.325-3.825 0-1.675.325-2.575 1.225-.9.9-1.15 2.575-.25 1.675.125 3.75t1.45 4.4Q15.4 26.8 17.2 29.1Zm14.55-14.7 3.6-3.45q-3.3-2.1-7.175-2.45Q24.3 8.15 20.6 9.6q1.5.15 2.975.6 1.475.45 2.9 1.075 1.425.625 2.75 1.425t2.525 1.7Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOthers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_others.30b93f32.svg";
export { ForwardRef as ReactComponent };